export const listingTypes = [
  {
    id: 'property',
    label: 'Property',
    fields: [
      { id: 'bedrooms', label: 'Bedrooms', type: 'number', icon: 'bed', filterable: true },
      { id: 'bathrooms', label: 'Bathrooms', type: 'number', icon: 'bath', filterable: true },
      { id: 'area', label: 'Area', type: 'number', suffix: 'm2', icon: 'home' },
      { id: 'erfSize', label: 'ERF size', type: 'number', suffix: 'm2', icon: 'land' },
      { id: 'parking', label: 'Parking', type: 'text', icon: 'car', filterable: true },
    ],
  },
  {
    id: 'vehicle',
    label: 'Vehicle',
    fields: [
      { id: 'make', label: 'Make', type: 'text', filterable: true },
      { id: 'model', label: 'Model', type: 'text', filterable: true },
      { id: 'year', label: 'Year', type: 'number', filterable: true },
      { id: 'mileage', label: 'Mileage', type: 'number', suffix: 'km', rangeFilter: true },
      { id: 'transmission', label: 'Transmission', type: 'select', options: ['Manual', 'Automatic'], filterable: true },
      { id: 'fuel', label: 'Fuel', type: 'select', options: ['Petrol', 'Diesel', 'Hybrid', 'Electric'], filterable: true },
      { id: 'drivetrain', label: 'Drivetrain', type: 'select', options: ['4x2', '4x4'], filterable: true },
      { id: 'colour', label: 'Colour', type: 'text' },
    ],
  },
  {
    id: 'car-hire',
    label: 'Car Hire',
    fields: [
      { id: 'transmission', label: 'Transmission', type: 'select', options: ['Manual', 'Automatic'], filterable: true },
      { id: 'fuel', label: 'Fuel', type: 'select', options: ['Petrol', 'Diesel', 'Hybrid', 'Electric'], filterable: true },
      { id: 'seats', label: 'Seats', type: 'number', filterable: true },
      { id: 'freeKms', label: 'Free kms', type: 'number', suffix: 'km/day' },
      { id: 'deposit', label: 'Deposit', type: 'text' },
    ],
  },
  {
    id: 'accommodation',
    label: 'Accommodation',
    fields: [
      { id: 'accommodationType', label: 'Type', type: 'select', options: ['Apartment', 'House', 'Room', 'Villa', 'Guesthouse', 'Hotel', 'Campsite'], filterable: true },
      { id: 'bedrooms', label: 'Bedrooms', type: 'number', icon: 'bed', filterable: true },
      { id: 'bathrooms', label: 'Bathrooms', type: 'number', icon: 'bath', filterable: true },
      { id: 'guests', label: 'Sleeps', type: 'number', icon: 'users', filterable: true },
      { id: 'parking', label: 'Parking', type: 'text', icon: 'car', filterable: true },
      { id: 'minimumStay', label: 'Minimum stay', type: 'number', suffix: 'nights' },
    ],
  },
  {
    id: 'equipment',
    label: 'Equipment',
    fields: [
      { id: 'condition', label: 'Condition', type: 'select', options: ['New', 'Used', 'Refurbished'], filterable: true },
      { id: 'brand', label: 'Brand', type: 'text', filterable: true },
      { id: 'model', label: 'Model', type: 'text' },
      { id: 'availability', label: 'Availability', type: 'text', filterable: true },
    ],
  },
];

export const defaultListingType = listingTypes[0].id;

export const normaliseListingType = (listingType) => (
  listingTypes.some((type) => type.id === listingType) ? listingType : defaultListingType
);

export const listingTypeConfigFor = (listingType) => (
  listingTypes.find((type) => type.id === normaliseListingType(listingType)) || listingTypes[0]
);

const formatGroupedNumber = (value) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const formatListingFieldValue = (field, value) => {
  const trimmedValue = String(value || '').trim();
  if (!trimmedValue) return '';

  const formattedValue = field.type === 'number' && /^-?\d+(\.\d+)?$/.test(trimmedValue)
    ? formatGroupedNumber(trimmedValue)
    : trimmedValue;

  return field.suffix ? `${formattedValue} ${field.suffix}` : formattedValue;
};

export const listingSpecsForAsset = (asset = {}, listingType) => {
  const config = listingTypeConfigFor(asset.listingType || listingType);
  const listingFields = asset.listingFields || {};

  return config.fields
    .map((field) => ({
      ...field,
      value: formatListingFieldValue(field, listingFields[field.id]),
    }))
    .filter((field) => field.value);
};
